import React, { useContext } from 'react';
import styled from 'styled-components';
import { HrFlexContainer, HrParagraph, HrPrimary, HrSecondary } from '@components/styles/hr-styles';
import { useTranslation } from 'react-i18next';
import useStore from '../store/useStore';
import { DisplaySettingsContext } from '../store/display-settings';

const Container = styled(HrFlexContainer)`
  font-family: 'Open Sans', sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 400;

  & a {
    color: ${HrSecondary};
    text-decoration: none;
    font-weight: 600;

    &.txt-overflow {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 130px;
    }
  }

  & a:hover,
  & a:active,
  & a:focus {
    text-decoration: none;
    color: ${HrSecondary};
  }

  & span {
    color: ${HrPrimary};
    margin-right: 4px;
    font-weight: 600;
  }
`;

const baseVacancyStatus = 5;

export const BreadCrumb = ({ vacancy, action }) => {
  const { getDataPostulant } = useStore();
  const [t] = useTranslation();
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  const showVacancyName = action !== 'edit' && vacancy?.status !== baseVacancyStatus;
  const isPostulationProcess = action !== 'edit';

  return (
    <Container width='auto' gap='4px'>
      {vacancy?.status !== 6 && (
        <>
          <a
            className='postulation-navigate-portal'
            style={{ color: darkMode ? 'white' : '', fontSize: `${14 + fontSizeSetting}px` }}
            href={getDataPostulant?.portalLink}
          >
            <span className='hr-Carret-left' />
            {t('postulant.portal')}
          </a>
        </>
      )}

      {showVacancyName && (
        <>
          <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
            {' '}
            -{' '}
          </HrParagraph>
          <a
            href={getDataPostulant?.vacancyLink}
            className='txt-overflow postulation-navigate-vacancy'
            title={vacancy?.name}
            style={{ color: darkMode ? 'white' : '', fontSize: `${14 + fontSizeSetting}px` }}
          >
            {vacancy?.name}
          </a>
        </>
      )}
      {isPostulationProcess && (
        <>
          <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
            {' '}
            -{' '}
          </HrParagraph>
          <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
            {t('postulant.postulation')}
          </HrParagraph>
        </>
      )}
    </Container>
  );
};
